import { render, staticRenderFns } from "./MyInstructorRequests.vue?vue&type=template&id=c3f940d0&"
import script from "./MyInstructorRequests.vue?vue&type=script&lang=js&"
export * from "./MyInstructorRequests.vue?vue&type=script&lang=js&"
import style0 from "./MyInstructorRequests.vue?vue&type=style&index=0&id=c3f940d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports